const boardFormats = [
  {
    id: 'Custom',
    name: 'Custom Format',
    columns: [],
  },
  {
    id: 'glad-sad-mad',
    name: 'Glad, Sad, Mad',
    columns: ['Glad', 'Sad', 'Mad'],
  },
  {
    id: 'engines-anchors',
    name: 'Engines & Anchors',
    columns: ['Engines', 'Anchors'],
  },
  {
    id: 'start-stop-continue',
    name: 'Start, Stop, Continue',
    columns: ['Start', 'Stop', 'Continue'],
  },
  {
    id: 'DAKI',
    name: 'DAKI (Drop, Add, Keep, Improve)',
    columns: ['Drop', 'Add', 'Keep', 'Improve'],
  },
  {
    id: 'KALM',
    name: 'KALM (Keep, Add, More, Less)',
    columns: ['Keep', 'Add', 'More', 'Less'],
  },
  {
    id: 'starfish',
    name: 'Starfish (Keep Doing, Less Of, More Of, Stop Doing, Start Doing)',
    columns: ['Keep Doing', 'Less Of', 'More Of', 'Stop Doing', 'Start Doing'],
  },
  {
    id: 'well-not-well-improved',
    name: "What went well? What didn't go well? What can be improved?",
    columns: [
      'What Went Well?',
      "What Didn't Go Well?",
      'What Can Be Improved?',
    ],
  },
  {
    id: 'WRAP',
    name: 'WRAP (Wishes, Risks, Appreciations, Puzzles)',
    columns: ['Wishes', 'Risks', 'Appreciations', 'Puzzles'],
  },
  {
    id: '4L',
    name: '4L (Liked, Learned, Lacked, Longed for)',
    columns: ['Liked', 'Learned', 'Lacked', 'Longed for'],
  },
  {
    id: 'LWW',
    name: 'LWW (Likes, Wishes, Wonders)',
    columns: ['Likes', 'Wishes', 'wonders'],
  },
  {
    id: '3W',
    name: '3W (Wow, Wondering, Worried)',
    columns: ['Wow', 'Wondering', 'Worried'],
  },
  {
    id: 'PMI',
    name: 'PMI (Plus, Minus, Interesting)',
    columns: ['Plus', 'Minus', 'Interesting'],
  },
  {
    id: 'TTNR',
    name: 'TTNR (Thumbs up, Thumbs down, New ideas, Recognition)',
    columns: ['Thumbs up', 'Thumbs down', 'New ideas', 'Recognition'],
  },
  {
    id: 'ESVP',
    name: 'ESVP (Explorer, Shopper, Vacationer, Prisoner)',
    columns: ['Explorer', 'Shopper', 'Vacationer', 'Prisoner'],
  },
  {
    id: 'FLAP',
    name: 'FLAP (Future, Lessons, Accomplishments, Problems)',
    columns: ['Future', 'Lessons', 'Accomplishments', 'Problems'],
  },
];

export default boardFormats;
